@if (isLoading) {
  <app-rings-loader></app-rings-loader>
}

<div class="modal-header">
  <h3 class="dialog-title text-center">{{ 'Add Attachment' | translate }}</h3>
</div>

<div mat-dialog-content>
  <div class="modal-content">
    <div class="modal-body">
      <form [formGroup]="form" class="attachment-form">
        <div class="upload-drop full-width" (click)="fileInput.click()"
          (drop)="onFileSelected($event.dataTransfer!.files); $event.preventDefault()"
          (dragover)="$event.preventDefault()">
          <p><strong>{{ 'Click to upload' | translate }}</strong> {{ 'or drag and drop' | translate }}</p>
          <small>JPG, JPEG, PNG, PDF {{ 'less than' | translate }} {{ data?.maxFileSizeMB ?? 1 }}MB</small>
          <input type="file" hidden #fileInput (change)="onFileSelected($event)">
        </div>

        @if (uploadedFile) {
          <div class="file-list full-width">
            <mat-icon>insert_drive_file</mat-icon>
            <div class="file-details">
              <div>{{ uploadedFile.name }}</div>
              <div class="progress-text">
                {{ (uploadedFile.size / 1024).toFixed(1) }}KB •
                @if (uploadedFile.uploading) {
                  {{ 'Uploading' | translate }}...
                }
                @if (!uploadedFile.uploading) {
                  {{ 'Done' | translate }}
                }
              </div>
              @if (uploadedFile.uploading) {
                <mat-progress-bar [value]="uploadedFile.progress"
                  mode="determinate">
                </mat-progress-bar>
              }
            </div>
            <button mat-icon-button (click)="removeFile()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }

        @if (showDescription) {
          <mat-form-field appearance="outline" class="full-width mt-2">
            <mat-label>{{ 'Description' | translate }}</mat-label>
            <textarea matInput formControlName="description" rows="4"></textarea>
          </mat-form-field>
        }
      </form>

      <div mat-dialog-actions class="createButton mt-2">
        <ng-container>
          <button class="btn modal-footer-btn save-modal-btn" (click)="save()">
          {{ 'Save' | translate }}</button>
        </ng-container>

        <div class="createButton mt-3" (click)="cancel()">
          <button class="btn modal-footer-btn cancel-modal-btn">{{ 'Close' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>